


   import Terrain from '../../terrain/Terrain'
   import GlassTerrain from '../../terrain/GlassTerrain'
   import MotelTerrain from '../../terrain/MotelTerrain'
   //import FacetBar from '../../esfind/FacetBar'
   import TerrainStars from '../../terrain/TerrainStars'
   import {  Link } from "react-router-dom"
   import {SearchBarBusCom,SojSearchBarBusCom, FacetBarBusCom} from '../../../containers'

   import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
   import { Icon, Button, Row, Col, Badge } from 'antd';

   import TerrainLocationSVPriceListView from '../../terrain/TerrainLocationSVPriceListView'
    import TerrainLocationListView from '../../terrain/TerrainLocationListView'
 
    import '../../../css/svlist_styles.css'
 


   const React = require('react')
  
    
   const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );

   const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

  
class SojSearchBoardContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        /*
        this.state = {  
           
            
            filters: {
                checkedParkingLabel:'Parking',
                checkedParking:true,
                disabledParking:false,

                checkedWifiLabel:'Wifi',
                checkedWifi:true,
                disabledWifi:false,

                checkedRestaurantLabel:'Restaurant',
                checkedRestaurant:true,
                disabledRestaurant:false,

                checkedPetfriendlyabel:'pet Friendlly',
                checkedPetfriendly:true,
                disabledPetfriendly:false,

                checkedRoomserviceLabel:'Room Service',
                checkedRoomservice:true,
                disabledRoomservice:false,

                checkedFrontdeskLabel:'24 Hours Front Desk',
                checkedFrontdesk:true,
                disabledFrontdesk:false,

                checkedFitnessLabel:'Fitness Center',
                checkedFitness:true,
                disabledFitness:false,

                checkedNonsmokingLabel:'Non Smoking',
                checkedNonsmoking:true,
                disabledNonsmoking:false,

                checkedShuttleLabel:'Airport Shuttle',
                checkedShuttle:true,
                disabledShuttle:false,

                checkedFamilyroomsLabel:'Family Room',
                checkedFamilyrooms:true,
                disabledFamilyrooms:false,

                checkedSpaLabel:'Spa',
                checkedSpa:true,
                disabledSpa:false,

                checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
                checkedEvcharging:true,
                disabledEvcharging:false,

                checkedWheelchairLabel:'Wheel Chair Accessibility',
                checkedWheelchair:true,
                disabledFWheelchair:false



            }
            
        }
        
        this.onChangeCbParking = this.onChangeCbParking.bind(me)
        */
        this.getAppDetails = this.getAppDetails.bind(this)
        this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(this)
        
        this.getMyHtml = this.getMyHtml.bind(this)
        this.getReserveHtmlButton = this.getReserveHtmlButton.bind(this)
        this.svsojourns = []
        this.title = 'PROD-NON-PROD Symmetry'
        this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
        this.getChildContainers = this.getChildContainers.bind(me)
        this.getChildContainersList = this.getChildContainersList.bind(me)
        this.getBedroomDetails = this.getBedroomDetails.bind(me)
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)

        this.starBody = this.starBody.bind(this)
    }
    starBody(o){
        let svrstars = {
            "sv_rating_no":o.avg_stars_rating ? o.avg_stars_rating : 5  ,
            "color": "#e8a01899"
        }
        return(<TerrainStars svrstars={svrstars} ></TerrainStars>)

    }
    /*
    onChangeCbParking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedParking'] =e.target.checked

        this.setState({filters:f} )

    }

    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbRestaurant=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRestaurant =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbPetfriendly=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPetfriendly =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbRoomservice=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRoomservice =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbFrontdesk=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFrontdesk =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbFitness=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFitness =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbNonsmoking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedNonsmoking =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbShuttle=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedShuttle =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbFamilyrooms=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFamilyrooms =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbSpa=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedSpa =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbEvcharging=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedEvcharging =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbWheelchair=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWheelchair =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbPool=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPool =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

        this.setState({filters:f} )

    }
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

        this.setState({filters:f} )

    }
    */
    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
    getBedroomDetails = (s, ctx)=>(event)=>{

        const det = 'Ssandara Queen Room with '
        console.log('sv**currryy' + s)
        s = (s? s : '2')
        if (s =='4'){
            return  det + '4' + 'Rooms'
        }else{
            return  det + s + 'Rooms'
        }

    }
    getAppDetailsMyReservation(paramQSpaceId, svcustProfile){
        console.log('caall getAppDetailsMyReservation', paramQSpaceId,svcustProfile)
        this.props.sojAndImagesSV("mancreek")
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetails(paramQ){
        
       // this.props.getSoDetails("mancreek")

       this.props.sojAndImagesSV("mancreek")
       
    }
    componentWillMount()	{
		console.log('=---json')
		let svsojourns = [
        
            {
                "name": "3",
                "id": 3,
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "4",
                "id": 4,
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
        console.log('**sv sohourns got from service ********')
		console.log(svsojourns)
		/* this.state = {
      			tasks: svtasks
    		}*/
//sv step1 dipatch action  dispatch is warpper with actiobcreateer by redux
//sv step2 reduce gives you new state that is available as props to render method
    			console.log('sv--tasks')
    			this.svsojourns = svsojourns
    			var ar = svsojourns;
              	//this.props.svWrappedfetchSVESSearchActionCreator(ar)
            this.getAppDetails('mancreek')
			
			
	

	}

     getMyHtml(){
        let ar = this.state.my_data;
        
        console.log(this.state)
        console.log(ar);
        const my_data = this.state.my_data;
        return my_data.map(o => {
            console.log(o)
            return (<li>{o.name}</li>)
        });
    }

    getReserveHtmlButton(o,customerId){
        if(customerId > 0){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/reservesvCustNew/${o.space_key}`}> MyReserve  </Link></Button>)
            

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetabode/svredbook/${o.space_key}`}> Reserve  </Link></Button>)
            
        }
        
    }
    getHotelAmenityList(ar){
        
        
        ar = ar || []
       return ar.map( (v, idx)=>{
           if(v.toLocaleLowerCase() == "swimming beach"){
            return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }else if(v.toLocaleLowerCase() == "tennis"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else if(v.toLocaleLowerCase() == "water"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else{

            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }
          })
       


    }
    getChildContainersListOld() {
      
/*
        const {
        checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
        disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
        checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
        checkedParking,checkedParkingLabel,disabledParking


        } = this.state.filters
        */
       const size = 'small'
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let customerId = -1
        let svCustomerId = -1
        const {dataProfile, svcustProfile} = this.props
        if(svcustProfile && svcustProfile.customerId > 0){
            customerId = svcustProfile.customerId 
            svCustomerId = customerId
            console.log('myreservationSpace')
            }else{
             console.log('internet userSpace')
            }
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.svessearch.data && (this.props.svessearch.data.length > 0)) {
            data = this.props.svessearch.data
        }
        if (this.props.svessearch.sojourns && (this.props.svessearch.sojourns.length > 0)) {
            sojourns = this.props.svessearch.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.svessearch && this.props.svessearch.my_data && (this.props.svessearch.my_data.length > 0)) {
            my_data = this.props.svessearch.my_data
        }else if(this.props.my_data && (this.props.my_data.length > 0)){
            my_data = this.props.my_data
        }

        const {svessearch, locationDataView,sv_esquery_data} = this.props
        const {my_esqueryText} = svessearch.sv_esquery_data
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
        console.log(this.props)
        console.log(my_esqueryText)
        console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
        /*
        if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
       let testimonyO = {
        avg_stars_rating :5
       }
        return (
            <div className="svr-det-pageWrapper">
            <header className="svr-header1">
            <h1><span><text style={{color:'#f0d8a9'}}> </text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
            </header>
            <SojSearchBarBusCom />
           
            {/*  
             <SearchBarBusCom />
            <header className="svr-header2">
                <h3>Cambsv Hotel Orlando Airport</h3>
                <p> 7986 Conway Road, Orlando, 32812, United States of America – Excellent location – show map </p>
            </header>
            */}
        
        
            <div className="svr-spacelist-contentWrapper">
                <article className="main-listhotels">
                {
                        my_data.map(o => {
                            let soj = o
                            //convet keys of o to uppercase
                            console.log('sv***soj**')
                            console.log(soj)
                            let priceInfo = {
                                o:o,
                                customerId:customerId
                            }
                            let reservekey = 'insvreview'
                            let svr_location = {
                                "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                                "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                                "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                                "county": soj['county'] ? soj['county'] : "albanyt",
                                "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                                "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                                "country": soj['country_name'] ? soj['country_name'] : "usa",
                               "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                               "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                                
                               "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                               "state":soj['state'] ? soj['state'] : "NY"

                            }
                            return (
                                <div className="svr-spacelist-box-row1">
                                <div className="svr-spacelist-boxr-1">
                                    <div className="gallery">
                                        <figure>
                                        <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                                        
                                        <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                         </Link> </span>
                                            
                                        </figure>
                                    </div>
                                </div>
                
                                <div className="svr-spacelist-boxl-2">
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                        <TerrainLocationListView svcustProfile={svcustProfile} reservekey={reservekey}  svrlocation={svr_location}></TerrainLocationListView>
                                        {/*  
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">{o.sojourn_name}</text>
                                                <span className="ter-l2 svr-hotel-location">{o.city_name?  o.city_name: "NamCity"} <Icon  style={{ color: '#eb2f96' }} type="environment" theme="filled" /><text>Shown On Map</text> <text>{o.nearest_airport_distance_mi? o.nearest_airport_distance_mi : '4' } miles from <span style={{fontSize: "14px"}} > <Icon  style={{ color: 'rgb(8, 44, 128)' }} type="dribbble-circle" theme="filled" /><text style={{paddingLeft: "3px"}}> {o.nearest_airports? o.nearest_airports : 'orlando Aiport'}</text></span>
                                            
                                                        awaysvGGL</text></span>
                                                       
                                                <span style={{fontSize: "18px"}} > <Icon  style={{ color: '#eb2f96' }} type="dingtalk-square" theme="filled" /><text style={{paddingLeft: "10px"}}>HoteSV Website</text></span>
                                                
                                            </p>
                                        */} 
                                        </div>
                                        <div className="box-right-listhotels">
                                        
                                        
                                        <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">{o.sv_rating?  o.sv_rating: "Excellent"}  </text>
                                                <text className="f12 d-block">{o.avg_stars_rating ? o.avg_stars_rating : 5 } rating </text>
                                            </p>
                                        
                                          
                                        </div>
                                    </div>
                
                
                                    <div className="box-outer-listhotels" style={{fontSize:"1.0em"}}>
                                        <div className="box-left-listhotels">
                                            {/* 
                                        <p className="m-para-text">
                                            {this.getHotelAmenityList(o.activity_name)}
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Wifi</text></span>
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Bath tub</text></span>
                                            
                                        </p>
                                        */}
                                            <p className="m-para-text">
                                            <div>
                                               
                                               <text className="f12  d-block"> {o.bedroomcode?  o.bedroomcode: "2"} SVQueen Beds </text>
                                               <span onClick={  this.deleteTaskCurryParams(o, this)}  style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="trophy" theme="filled" /><text style={{paddingLeft: "10px", color: "rgb(189, 33, 33)"}}>6 Rooms Left</text></span>
                                            </div>
                                                {this.getHotelAmenityList(o.en_activity_name_lvl)}
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Wifi</text></span>
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Bath tub</text></span>
                                                
                                                
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">2night, 2days </text>
                                                <text className="svr-hotel-price d-block"> <a className="et-icon-angle-left" href="#" className="sv-page-con"><span style={{ "font-size": "30px" }}></span> </a> <a ><span style={{ "font-size": "30px" }} ></span> </a>$116 </text>
                                               
                                            </p>
                                            {this.getReserveHtmlButton(o,customerId)
                                              
                                            }
                {/*  
                                            <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetabode/svredbook/${o.space_key}`}> Reserve  </Link></Button>
                                            */}
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                                
                            )
                        })
                    }
                   
                    <div className="svr-spacelist-box-row1 svr-spacelist-box-row1-last">
                        <div className="svr-spacelist-boxr-1">
                            <div className="gallery">
                                <figure>
                                <span>	<Link to={`/svredsojourn`} > 
                                
                                <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                 </Link> </span>
                                   
                                </figure>
                            </div>
                        </div>
        
                        <div className="svr-spacelist-boxl-2">
                            <div className="box-outer-listhotels">
                                <div className="box-left-listhotels">
                                    <p className="m-para-text-first">
                                        <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                        <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                away</text></span>
                                       
                                    </p>
                                </div>
                                <div className="box-right-listhotels">
                                    <p className="m-para-text-first">
                                        <text className="svr-hotel-rating">Excellent </text>
                                        <text className="f12 d-block">12345 reviews </text>
                                    </p>
                                </div>
                            </div>
        
        
                            <div className="box-outer-listhotels">
                                <div className="box-left-listhotels">
                                    <p className="m-para-text">
                                        <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                        <text className="f12  d-block"> 2 Queen Beds </text>
                                    </p>
                                </div>
                                <div className="box-right-listhotels">
                                    <p className="m-para-text">
                                        <text className="svr-hotel-stay">1night, 2days </text>
                                        <text className="svr-hotel-price d-block">$116 </text>
                                    </p>
                                </div>
                            </div>
                            
                            <div className="box-outer-listhotels">
                                <div className="box-left-listhotels">
                                    <p className="svr-hotel-avail">
                                        <text className="f19"> Only 8 Rooms left </text>
                                    </p>
                                </div>
                                <div className="box-right-listhotels">
                                    <p>
                                  
                                    </p>
                                </div>
                            </div>
        
        
                        </div>
        
        
                    </div>
                </article>
        
               
                <aside className="siberbar2">
        
                    <h3> Filter By</h3>
                    <FacetBarBusCom  my_esqueryText={my_esqueryText} locationDataView={locationDataView} />
                    {/*  */}
                    <div className="svr-rating-content">
                        <p className="svr-hotel-rating" >Excelllent 5.0
                        </p>
        
                    </div>
        
                    <div className="svr-num-reviews-content">
                        <p>12,364 reviews
                        </p>
        
                    </div>
                    <div className="svr-review-author-comment-content">
        
                        <p>“The property has a great bar/restaurant in the lobby, which is good because there isn't much
                            around
                            there to choose from food wise.”
                        </p>
                        <p> Jane Ellison</p>
                    </div>
        
                    <div className="svr-fa-stars-content">
                        <p>
                        {this.starBody(testimonyO)}
                        </p>
                    </div>
                </aside>
        
            </div>
        
        
        
        
            <br />
        
        
        </div>
            
            )
    }
    getChildContainers() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        if (this.props.sojourns && (this.props.sojourns.length > 0)) {
            sojourns = this.props.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
        /*
        if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
        return (
            <div>


<div className="box-outer-listhotels">
    <div className="box-left-listhotels">
        <p>
            
            <text className="f24" >SV Cambria Hotel Oraland </text>
            <span className="f12" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>
           
        </p>
       
    </div>

    <div className="box-right-listhotels">
      
        <p>
            <text   className="f19">Excellent </text>
            <text className="f12 d-block"  >12345 reviews </text>
            <span className="f12 sv-hide" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>
            
        </p>
       
        
    </div>
</div>


<div className="box-outer-listhotels">
    <div className="box-left-listhotels">
        <p>
            
            <text className="f19"> Standard Queen Room With two Queen Rooms & shower </text>
            <text className="f12"> 2 Queen Beds </text>
            
        </p>

    </div>

    <div className="box-right-listhotels">
      
        <p>
            <text   className="f19">1night, 2days </text>
            <text   className="f22 d-block">$116 </text>
           
            
        </p>
        
    </div>
</div>
<div className="box-outer-listhotels">
    <div className="box-left-listhotels">
        <p>
            
            <text className="f19"> Only 8  Rooms left </text>
           
            
        </p>

    </div>

    <div className="box-right-listhotels">
      
        <p>
           
           
            
        </p>
        
    </div>
</div>
            
            </div>
           
            
            )
    }

    getChildContainersOld() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        if (this.props.sojourns && (this.props.sojourns.length > 0)) {
            sojourns = this.props.sojourns

            console.log('sv******************this.props')
            console.log(this.props)

            console.log('sv******************this.props....')
        }
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
        /*
        if (this.props.loading) {
            return <Loader type='spinner' />
        } else if (this.props.error) {
            return <ErrorWidget error={this.props.error} />
        }
        */
        return (
            <div>

  <a target="_blank" rel="noopener noreferrer" href="https://www.booking.com/hotel/us/san-diego-del-mar.html?label=gen173nr-1FCAEoggI46AdIM1gEaIkCiAEBmAExuAEYyAEP2AEB6AEB-AECiAIBqAIEuAKNu_CxBsACAdICJGY4NTJhN2NkLTkxMmItNDE1Zi04ZGI4LTVjYWRjNDU2N2M3NNgCBeACAQ&amp;aid=304142&amp;ucfs=1&amp;arphpl=1&amp;checkin=2024-05-24&amp;checkout=2024-06-07&amp;dest_id=20015725&amp;dest_type=city&amp;group_adults=2&amp;req_adults=2&amp;no_rooms=1&amp;group_children=0&amp;req_children=0&amp;hpos=1&amp;hapos=1&amp;sr_order=popularity&amp;srpvid=025e05dca08401b2&amp;srepoch=1715217706&amp;all_sr_blocks=26285401_246425381_0_42_0&amp;highlighted_blocks=26285401_246425381_0_42_0&amp;matching_block_id=26285401_246425381_0_42_0&amp;sr_pri_blocks=26285401_246425381_0_42_0__250600&amp;from_sustainable_property_sr=1&amp;from=searchresults&amp;map=1" className="a83ed08757 f88a5204c2 a1ae279108 b98133fb50"><span><span className="aee5343fdb def9bc142a" data-testid="address">Carmel Valley, San Diego</span><span className="aee5343fdb def9bc142a">Show on map</span></span></a><span className="aee5343fdb"><span className="f419a93f12"><span aria-expanded="false" data-testid="distance">16.1 miles from downtown</span></span></span><span className="aee5343fdb"><span className="f419a93f12"><span aria-expanded="false">Beach Nearby</span></span></span>
  
                {

                     my_data.map(o => {
                        console.log(o)
                        return (<li>{o.sojourn_name}</li>)
                    })
                }
            </div>
           
            
            )
    }

    

    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        
       /*
       const { title, sojourns} = this

        const getMyHtml = () => {
            return this.props.sojourns.map(o => {
                console.log(o)
                return (<li>{o.sojourncode}</li>)
            });
        }
    
        const getMyData = () => {
            let arso = sojourns
            console.log("dino data");
            console.log(sojourns);
            console.log("end");
            return arso;TerrainLocationSVPriceListView.js
        }
       */
        const { cookies } = this.props;
        let svcookoffer_val = "yyXX"
        console.log('********OCT25**************** COOKIES SET svcookoffer START')

        if(cookies ){
            cookies.set('svcookoffer', svcookoffer_val, { path: '/' });
        }else{
            console.log('********OCT25****************FAILED to set cookies bull *** COOKIES SET svcookoffer START')

        }
        

          return (

            
            <div className="col-md-12">

    
                
                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersList()}></MotelTerrain>
            </div>
        )
        
    }


    getChildContainersList() {
      
        /*
                const {
                checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
                disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
                checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
                checkedParking,checkedParkingLabel,disabledParking
        
        
                } = this.state.filters
                */
               const size = 'small'
                const legend = [{
                    "sojourncode": "100",
                    "vernacularcode": "EN",
                    "sojourn_name": "253 Mancreek Resort"
                },
                {
                    "sojourncode": "101",
                    "vernacularcode": "EN",
                    "sojourn_name": "253 John Resort"
                }]
                let customerId = -1
                let svCustomerId = -1
                const {dataProfile, svcustProfile} = this.props
                if(svcustProfile && svcustProfile.customerId > 0){
                    customerId = svcustProfile.customerId 
                    svCustomerId = customerId
                    console.log('myreservationSpace')
                    }else{
                     console.log('internet userSpace')
                    }
                let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
                if (this.props.svessearch.data && (this.props.svessearch.data.length > 0)) {
                    data = this.props.svessearch.data
                }
                if (this.props.svessearch.sojourns && (this.props.svessearch.sojourns.length > 0)) {
                    sojourns = this.props.svessearch.sojourns
        
                    console.log('sv******************this.props')
                    console.log(this.props)
        
                    console.log('sv******************this.props....')
                }
                if (this.props.svessearch && this.props.svessearch.my_data && (this.props.svessearch.my_data.length > 0)) {
                    my_data = this.props.svessearch.my_data
                }else if(this.props.my_data && (this.props.my_data.length > 0)){
                    my_data = this.props.my_data
                }
        
                const {svessearch, locationDataView} = this.props
                console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
                console.log(this.props)
                console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
                /*
                if (this.props.loading) {
                    return <Loader type='spinner' />
                } else if (this.props.error) {
                    return <ErrorWidget error={this.props.error} />
                }
                */
               let testimonyO = {
                avg_stars_rating :5
               }
                return (
                    <div className="svr-det-pageWrapper">
                    <header className="svr-header1">
                    <h1><span><text style={{color:'#f0d8a9'}}>Choose Your Abode</text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                    </header>
                    <SojSearchBarBusCom />
                    
                    {/*  
                    <SearchBarBusCom />
                    <header className="svr-header2">
                        <h3>Cambsv Hotel Orlando Airport</h3>
                        <p> 7986 Conway Road, Orlando, 32812, United States of America – Excellent location – show map </p>
                    </header>
                    */}
                
                
                    <div className="svr-spacelist-contentWrapper">
                        <article className="main-listhotels">
                        {
                                my_data.map(o => {
                                    let soj = o
                                    //convet keys of o to uppercase
                                    console.log('sv***soj**')
                                    console.log(soj)
                                    let priceInfo = {
                                        o:o,
                                        customerId:customerId
                                    }
                                    let reservekey = 'insvreview'
                                    let svr_location = {
                                        "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                                        "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                                        "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                                        "county": soj['county'] ? soj['county'] : "albanyt",
                                        "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                                        "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                                        "country": soj['country_name'] ? soj['country_name'] : "usa",
                                       "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                                       "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                                        
                                       "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                                       "state":soj['state'] ? soj['state'] : "NY"
        
                                    }
                                    return (
                                        <div className="svr-spacelist-box-row1">
                                        <div className="svr-spacelist-boxr-1">
                                            <div className="gallery">
                                                <figure>
                                                <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                                                
                                                <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                                 </Link> </span>
                                                    
                                                </figure>
                                            </div>
                                        </div>
                        
                                        <TerrainLocationSVPriceListView priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  svrlocation={svr_location}></TerrainLocationSVPriceListView>

                                    </div>
                                        
                                    )
                                })
                            }
                           
                            <div className="svr-spacelist-box-row1 svr-spacelist-box-row1-last">
                                <div className="svr-spacelist-boxr-1">
                                    <div className="gallery">
                                        <figure>
                                        <span>	<Link to={`/svredsojourn`} > 
                                        
                                        <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                         </Link> </span>
                                           
                                        </figure>
                                    </div>
                                </div>
                
                                <div className="svr-spacelist-boxl-2">
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                                <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                        away</text></span>
                                               
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text-first">
                                                <text className="svr-hotel-rating">Excellent </text>
                                                <text className="f12 d-block">12345 reviews </text>
                                            </p>
                                        </div>
                                    </div>
                
                
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                                <text className="f12  d-block"> 2 Queen Beds </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p className="m-para-text">
                                                <text className="svr-hotel-stay">1night, 2days </text>
                                                <text className="svr-hotel-price d-block">$116 </text>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div className="box-outer-listhotels">
                                        <div className="box-left-listhotels">
                                            <p className="svr-hotel-avail">
                                                <text className="f19"> Only 8 Rooms left </text>
                                            </p>
                                        </div>
                                        <div className="box-right-listhotels">
                                            <p>
                                          
                                            </p>
                                        </div>
                                    </div>
                
                
                                </div>
                
                
                            </div>
                        </article>
                
                       
                        <aside className="siberbar2">
                
                            <h3> Filter By</h3>
                            <FacetBarBusCom  locationDataView={locationDataView} />
                            {/*  */}
                            <div className="svr-rating-content">
                                <p className="svr-hotel-rating" >Excelllent 5.0
                                </p>
                
                            </div>
                
                            <div className="svr-num-reviews-content">
                                <p>12,364 reviews
                                </p>
                
                            </div>
                            <div className="svr-review-author-comment-content">
                
                                <p>“The property has a great bar/restaurant in the lobby, which is good because there isn't much
                                    around
                                    there to choose from food wise.”
                                </p>
                                <p> Jane Ellison</p>
                            </div>
                
                            <div className="svr-fa-stars-content">
                                <p>
                                {this.starBody(testimonyO)}
                                </p>
                            </div>
                        </aside>
                
                    </div>
                
                
                
                
                    <br />
                
                
                </div>
                    
                    )
            }
}
/*
SojSearchBoardContainer = connect((state) => {
    return {
        loading: state.pnpReducer.loading,
        hosts: state.pnpReducer.pnp_host_data,
        dbs: state.pnpReducer.pnp_db_data,
        lastUpdate: state.pnpReducer.pnp_update,
        error: state.pnpReducer.error
    }
}, {

    })(SojSearchBoardContainer)
*/
export default SojSearchBoardContainer